import { Pipe, PipeTransform } from '@angular/core';
import { StoresService } from '../services/stores/stores.service';

@Pipe({
  name: 'percentageSymbol'
})
export class PercentageSymbolPipe implements PipeTransform {
  symbol:string = ''
  constructor(
    private stores: StoresService,
  ){
    // this.getConfigStore()
  }

  // getConfigStore(){
  //   this.stores.getAllConfig()
  //   .subscribe((config:any[]) => config.map(({name, value}) => name === 'simbol-currency' && (this.currency = value)))
  //  }

  transform(value: string | number): string {
    // console.log(value)
    // let price = value ? Number(value.toString().match(/^\d+(?:\.\d{0,2})?/)) : ''; 
    return `${value}%`;
  }

}
